import React from "react";
import { Field } from "redux-form";
import * as domain from "common/domain";
import * as validations from "common/validations";
import * as normalizers from "common/normalizers";
import * as utils from "common/utils";
import InputPack from "components/InputPack";

class DistributionApplications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    _getTitle = (budget, refData, application, isAllBlocks) => {
        if (isAllBlocks) return "All pastoral blocks";

        const block = budget.blocks.find((b) => b.id === application.blockId);
        if (block) {
            return block.name;
        }

        const enterprise = budget.enterprises.find((e) => e.id === application.enterpriseId);
        if (enterprise) {
            return utils.valueToText(refData.enterpriseTypes, enterprise.type);
        }

        return "Destination";
    };

    render() {
        const { isAllBlocks, application, budget, refData, onMonthChange } = this.props;

        let title = this._getTitle(budget, refData, application, isAllBlocks);

        return (
            <tr>
                <td className="td--keyValuePair" title={title}>
                    <h5 className="u-mt-0 u-textEllipsis">{title}</h5>
                </td>
                {domain.farmYear.map((month) => {
                    return (
                        <td key={month} className="u-textCenter">
                            <Field name={`months[${month}]`} placeholder="0" type="text" maxLength="3" onChange={onMonthChange(application, month)} noLabel={true} hideErrors={true} normalize={normalizers.integer} validate={[validations.maxValue(100)]} component={InputPack} />
                        </td>
                    );
                })}
                <td className="td--alignTop u-textCenter">
                    <h5 className={`${application.total > 100 ? "u-textError" : ""}`}>{application.total} %</h5>
                </td>
            </tr>
        );
    }
}

export default DistributionApplications;
